import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/auth";
import { LoginPage } from "./pages/LoginPage";
import { HomePage } from "./pages/HomePage";
import { MapPage } from "./pages/MapPage";
import { AreaPage } from "./pages/AreaPage";
import { UnitPage } from "./pages/UnitPage";
import { KanaPracticePage } from "./pages/KanaPracticePage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { TracePage } from "./pages/TracePage";
import { TypingPage } from "./pages/TypingPage";
import { useFlushPendingUnits } from "./lib/use-flush-pending-units";

export function App() {
  useFlushPendingUnits();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* 誰でも登録は止めた（学習者は学校管理者が CSV で登録する）。/signup はログインへ */}
      <Route path="/signup" element={<Navigate to="/login" replace />} />
      <Route path="/" element={<RequireAuth><MapPage /></RequireAuth>} />
      <Route path="/room" element={<RequireAuth><HomePage /></RequireAuth>} />
      <Route path="/area/:id" element={<RequireAuth><AreaPage /></RequireAuth>} />
      <Route path="/unit/:sectionId/:n" element={<RequireAuth><UnitPage /></RequireAuth>} />
      <Route path="/kana/:kind" element={<RequireAuth><KanaPracticePage /></RequireAuth>} />
      <Route path="/leaderboard" element={<RequireAuth><LeaderboardPage /></RequireAuth>} />
      <Route path="/trace/hiragana" element={<RequireAuth><TracePage /></RequireAuth>} />
      <Route path="/typing" element={<RequireAuth><TypingPage /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
